import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { Td, Tr } from '@chakra-ui/react'
import GlobalContext from 'context/GlobalContext'

const TbodyDispatchCorrected = ({ data, onClose = null }) => {
  const { setTargetData } = useContext(GlobalContext)

  const newItemData = {
    // IDs
    id: data?.id,
    outputFormItemCorrected_id: data?.outputFormItem_id,
    outputFormCorrected_id: data?.outputForm_id,
    
    // Item information
    item: data?.item,
    item_corrected: data?.item,
    item_output_corrected: data?.item,
    
    // Reference and product info
    reference: data?.reference,
    reference_corrected: data?.reference,
    code_product: data?.code_product,
    code_product_corrected: data?.code_product,
    
    // Quantities (initialize with current values or 0)
    quantity_dispatch: data?.quantity_go_out || 0,
    quantity_dispatch_corrected: data?.quantity_go_out || 0,
    quantity_dispatch_product: data?.quantity_go_out_product || 0,
    quantity_dispatch_product_corrected: data?.quantity_go_out_product || 0,
    quantity_go_out_corrected: data?.quantity_go_out || 0,
    quantity_go_out_product_corrected: data?.quantity_go_out_product || 0,
    
    // Business unit and descriptions
    code_businessUnit: data?.code_unit_measurement,
    code_businessUnit_corrected: data?.code_unit_measurement,
    output_form_item_description: data?.output_form_item_description,
    output_form_item_description_corrected: data?.output_form_item_description,
    description_product: data?.description_product,
    description_product_corrected: data?.description_product,
    
    // Output form
    code_outputForm: data?.code_outputForm,
    code_outputForm_corrected: data?.code_outputForm
  }

  const handleSearchItem = () => {
    setTargetData(newItemData)
    if (onClose) onClose()
  }

  return (
    <Tr onClick={handleSearchItem}>
      <Td className='text-center'>{data?.code_outputForm ?? 'N/A'}</Td>
      <Td className='text-center'>{data?.item ?? 'N/A'}</Td>
      <Td className='text-center'>{data?.reference ?? 'N/A'}</Td>
      <Td className='text-center'>{data?.custom_clearance ?? ''}</Td>
      <Td className='text-center'>{data?.code_product ?? 'N/A'}</Td>
      <Td className='text-center'>{data?.description ?? 'N/A'}</Td>
      <Td className='text-center'>{data?.code_businessUnit ?? 'N/A'}</Td>
      <Td className='text-center'>{data?.quantity_go_out ?? 'N/A'}</Td>
      <Td className='text-center'>{data?.code_unit_measurement ?? 'N/A'}</Td>
      <Td className='text-center'>{data?.quantity_go_out_product ?? 'N/A'}</Td>
    </Tr>
  )
}

TbodyDispatchCorrected.propTypes = {
  data: PropTypes.object
}

export default TbodyDispatchCorrected
